import { render, staticRenderFns } from "./DesignText.vue?vue&type=template&id=11dfe985&"
import script from "./DesignText.vue?vue&type=script&lang=js&"
export * from "./DesignText.vue?vue&type=script&lang=js&"
import style0 from "./DesignText.vue?vue&type=style&index=0&id=11dfe985&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports